<template>
  <section class="about-chapter-3">
    <div class="about-chapter-3-content">
      <AboutAnchorNav :section="3" />

      <v-container class="px-sm-8 py-0 pa-md-0">
        <div class="mb-12 mb-md-16">
          <v-row align="start" justify="space-between" no-gutters>
            <v-col cols="12" md="3" lg="2">
              <p class="text-section text--fes-magenta mb-4 mb-mb-0">What is social-ecological transformation?
                <span></span>
              </p>
            </v-col>

            <v-col cols="12" md="8">
              <p class="text-body text--fes-blue mb-0">
                <a href="https://asia.fes.de/news/set-cities-asia" target="_blank">Social-ecological transformation</a> questions current development paradigms. It seeks to understand social, ecological, and economic aspects as interlinked and equal concerns in policymaking, thereby achieving a truly sustainable global transformation in which people and nature take centre stage. In cities, this means pursuing sustainable and just urbanisation, lowering emissions, conserving natural resources, and building socially inclusive governments and societies.
              </p>                       
            </v-col>
          </v-row>
        </div>
    
        <div>
          <v-row align="start" justify="space-between" no-gutters>
            <v-col cols="12" md="3" lg="3">
              <p class="text-section text--fes-magenta mb-4">
                Reimagining the city: Core areas of social-ecological transformation
              </p>
            </v-col>

            <v-col cols="12" md="8">
              <v-row align="start" justify="start">
                <v-col cols="12" sm="9" md="6" 
                  v-for="n in coresectors" :key="n.icon"
                  class="about-chapter-3-coresectors mb-3 mb-md-0">
                    <div class="mb-3">
                      <img :src="require('@/assets/about/chapter1/about-ch1-coresectors-' + `${n.icon}` + '.svg')" />
                      <p class="text-card text--fes-blue mb-0">{{ n.label }}</p>
                    </div>
                    <p class="text-body text--fes-blue mb-0">{{ n.desc }}</p>
                </v-col>
              </v-row>                 
            </v-col>
          </v-row>
        </div> 
      </v-container>      
    </div>

    <div class="about-chapter-3-hero">
      <v-container class="px-4 px-sm-8 py-0 pa-md-0">
        <v-row justify="center" no-gutters>
          <v-col cols="12" md="10">
            <p class="text-section white--text text-decoration-underline text-center mb-0">
              <!-- The “Social City” lies at the heart of social-ecological transformation. Beyond affordable housing and mobility, the Social City is collaborative and holistic. It embraces diversity and resists segregation. It enables people to shape their urban environments by participating in governance at all levels. -->
              <router-link :to="'/map'" style="text-decoration: none;">Find out more about the Social-Ecological Transformation of Asias cities on our map.</router-link>
            </p>
          </v-col> 
        </v-row>       
      </v-container>
    </div>

    <!-- <div class="about-chapter-3-banner">
      <img src="@/assets/about/chapter3/about-ch3-banner-full.png" width="100%" />
    </div>     -->
  </section>  
</template>

<script>
import AboutAnchorNav from '@/components/layout/AboutAnchorNav'

export default {
  name: 'AboutChapter3',
  components: {
    AboutAnchorNav
  },
  data() {
    return {
      coresectors: [
        {
          "label":"Transportation and housing",
          "icon":"transportation",
          "desc":"Transportation and housing connect people to work, leisure, and services, thereby enabling people’s participation in society. How might we do this while protecting the climate  and people’s health?"
        },
        {
          "label":"Inequality",
          "icon":"inequality",
          "desc":"Ecological and economic risks weigh heavier on the marginalised and poor. How might we ensure their access to basic services and pathways out of poverty?"
        },
        {
          "label":"People-centered urban planning",
          "icon":"wellbeing",
          "desc":"A good life is a basic right, yet it remains hard to achieve for all. How might we place it at the core of public policy?"
        },
        {
          "label":"Urban energy",
          "icon":"urbanenergy",
          "desc":"Cities consume lots of energy and add to climate change. How might we guarantee energy security and take care of the planet?"
        }
      ]
    };
  },
}
</script>

<style lang="scss" scoped>
.about-chapter-3 {
  scroll-margin-top: 70px;
}

.about-chapter-3-content {
  padding: 96px 0;
  background: linear-gradient(180deg, #E5F1F8 0%, #E8E5F1 100%);

  .about-chapter-3-coresectors:nth-child(-n+2) {
    margin-bottom: 32px;   
  }      

  .about-chapter-3-coresectors {

    div {
      img {
        vertical-align: middle;
        margin-right: 8px;
      }

      p.text-card {
        display: inline-block;
      }      
    }
  }  
}

.about-chapter-3-hero {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("~@/assets/about/chapter3/about-ch3-banner-full.png");
  // background: url("~@/assets/about/chapter1/about-ch1-banner.png");   
  padding: 144px 0;   
  background-position:bottom; 
  background-attachment: fixed; 
  -o-background-size:cover; 
  -moz-background-size:cover; 
  -webkit-background-size:cover; 
  background-size:cover; 
  background-repeat:no-repeat;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .about-chapter-3-content {
    padding: 48px 4px; 
  }

  .about-chapter-3-hero {
    background-attachment: scroll;     
    padding: 72px 0;   
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {

  .about-chapter-3-content {
    .about-chapter-3-coresectors {
      margin-bottom: 36px;
    }

    .about-chapter-3-coresectors:last-child {
      margin-bottom: unset;   
    }  
  }  
}
</style>